<div class="owner-container">
    <div class="owner-content">
        <div class="owner-header">
            <div class="owner-header-image">
                <img class="logo" [src]="'https:' + sponsorOnboardingCMSData?.ownerDetailsIcon.fields.file.url" alt="business-icon">
            </div>
            <div class="owner-header-details">
                <div class="header-title">
                    {{sponsorOnboardingCMSData?.ownerDetailsLabel}}
                </div>
                <div class="header-desc">
                    {{sponsorOnboardingCMSData?.ownerDetailsDesc}}
                </div>
            </div>
        </div>

        <div class="owner-field-container">

            <div class="">
                <app-toggle-field [fieldTitle]="sponsorOnboardingCMSData?.ownerAccountIdenticalLabel" (toggleValue)="ownerDetails.isOwnerPartnerIdenticle"
                (toggleValueChange)="ownerValueChange($event, 'isOwnerPartnerIdenticle')">
                </app-toggle-field>
            </div>

            <div class="owner-fields-primary" *ngIf="!ownerDetails.isOwnerPartnerIdenticle">
                <app-custom-select-dropdown [fieldTitle]="getGenericLabels?.Title" [required]="true" [width]="100" [widthUnit]="'%'" [options]="salutationTypeList" 
                (valueChange)="valueChange($event, 'title')" [value]="ownerDetails.title"
                [readOnly]="ownerDetails.isOwnerPartnerIdenticle ? true : false">
                </app-custom-select-dropdown>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.FirstName" [width]="100" [widthUnit]="'%'" [required]="true" [value]="ownerDetails.firstName"
                (valueChange)="ownerValueChange($event, 'firstName')" [disableEdit]="ownerDetails.isOwnerPartnerIdenticle ? true : false">
                </app-custom-text-field>

                <app-custom-text-field [fieldTitle]="getGenericLabels?.LastName" [width]="100" [widthUnit]="'%'" [required]="true" [value]="ownerDetails.lastName"
                (valueChange)="ownerValueChange($event, 'lastName')" [disableEdit]="ownerDetails.isOwnerPartnerIdenticle ? true : false">
                </app-custom-text-field>
            </div>

            <div class="owner-fields-secondary">
                <div>
                    <app-custom-text-field [fieldTitle]="getGenericLabels?.NationalID" [width]="100" [widthUnit]="'%'" [required]="true" [value]="ownerDetails.identificationNumber"
                    (valueChange)="ownerValueChange($event, 'identificationNumber')">
                    </app-custom-text-field>
                </div>

                <div *ngIf="!ownerDetails.isOwnerPartnerIdenticle">
                    <app-custom-text-field [fieldTitle]="getGenericLabels?.Phone" [width]="100" [widthUnit]="'%'" [required]="true" [value]="ownerDetails.phone"
                    (valueChange)="ownerValueChange($event, 'phone')" [disableEdit]="ownerDetails.isOwnerPartnerIdenticle ? true : false">
                    </app-custom-text-field>
                </div>

            </div>

            <div class="owner-fields-full" *ngIf="!ownerDetails.isOwnerPartnerIdenticle">
                <app-custom-text-field [type]="'email'" [fieldTitle]="getGenericLabels?.Email" [width]="100" [widthUnit]="'%'" [required]="true" [value]="ownerDetails.email"
                (valueChange)="ownerValueChange($event, 'email')" [disableEdit]="ownerDetails.isOwnerPartnerIdenticle ? true : false"
                [toolTipMessage]="validEmailMsg" [showError]="!isValidEmail">
                </app-custom-text-field>

                <!-- <app-multi-select-dropdown [fieldTitle]="getGenericLabels?.CommunicationChannel" [required]="true" [width]="100" [widthUnit]="'%'" [options]="commChannelList"
                (valueChange)="valueChange($event, 'communicationChannel')" [value]="ownerDetails.isOwnerPartnerIdenticle ? partnerAccDetails.communicationChannel : ownerDetails.communicationChannel"
                [disabled]="ownerDetails.isOwnerPartnerIdenticle ? true : false">
                </app-multi-select-dropdown> -->
            </div>

            <div class="divider"></div>
        </div>
    </div>
</div>